//by Tiago Salteiro
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getPermissions } from "../../functions/permissions";
import "../../styles/sidebar.css";
import { useLocation, useNavigate } from "react-router-dom";

const SideBar = React.memo(() => {
  interface Permissions {
    [key: string]: boolean;
  }
  const image_bp = `${process.env.PUBLIC_URL}/assets/Images/Logo bp.png`;

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [permissions, setPermissions] = useState<Permissions>({});

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prev) => !prev); // Simplified toggle using prev state
  }, []);

  // Fetch permissions only when the component mounts or when permissions are updated
  useEffect(() => {
    const fetchPermissions = async () => {
      const fetchedPermissions = await getPermissions();

      //Only update state if permissions have changed
      setPermissions((prevPermissions) =>
        JSON.stringify(prevPermissions) !== JSON.stringify(fetchedPermissions)
          ? fetchedPermissions
          : prevPermissions
      );
    };

    fetchPermissions();
  }, []);

  // Memoize elements to avoid unnecessary recalculations
  const elements = useMemo(
    () => [
      {
        pageHeader: "Dashboard",
        pageLink: "/Dashboard",
        pageIcon: "space_dashboard",
        permissionKey: "Dashboard",
      },
      {
        pageHeader: "Vendas de Loja",
        pageLink: "/StoreSales",
        pageIcon: "shopping_basket",
        permissionKey: "Store",
      },
      {
        pageHeader: "Vendas de Combustível",
        pageLink: "/FuelSales",
        pageIcon: "whatshot",
        permissionKey: "Fuel",
      },
      {
        pageHeader: "Venda Sugerida",
        pageLink: "/Upselling",
        pageIcon: "shopping_cart",
        permissionKey: "Upselling",
      },
      {
        pageHeader: "Mix Ultimate",
        pageLink: "/MixUltimate",
        pageIcon: "opacity",
        permissionKey: "MixUltimate",
      },
      {
        pageHeader: "PD&GO",
        pageLink: "/PD&GO",
        pageIcon: "diversity_3",
        permissionKey: "pdGO",
      },
      {
        pageHeader: "Equipa",
        pageLink: "/Team",
        pageIcon: "group",
        permissionKey: "Team",
      },
      {
        pageHeader: "Cliente Mistério",
        pageLink: "/MisteryClient",
        pageIcon: "emoji_people",
        permissionKey: "MisteryClient",
      },
      {
        pageHeader: "Auditorias",
        pageLink: "/Auditorias",
        pageIcon: "pageview",
        permissionKey: "Audits",
      },
      // {
      //   pageHeader: "Horário",
      //   pageLink: "/Schedule",
      //   pageIcon: "event_available",
      //permissionKey: 'Schedule',
      // },
      {
        pageHeader: "Formação",
        pageLink: "/Training",
        pageIcon: "library_books",
        permissionKey: "training",
      },
      {
        pageHeader: "Controler",
        pageLink: "/Controler",
        pageIcon: "play_arrow",
        permissionKey: "Controller",
      },
      {
        pageHeader: "Mensagens",
        pageLink: "/Messages",
        pageIcon: "mail",
        permissionKey: "Messages",
      },
      // { pageHeader: "Presencial", pageLink: "/Presencial", pageIcon: "groups", permissionKey: 'Presencial', },
      {
        pageHeader: "Definições",
        pageLink: "/Config",
        pageIcon: "settings",
        permissionKey: "Config",
      },
    ],
    []
  );

  return (
    <>
      <button className="sidebar-toggle-button" onClick={toggleSidebar}>
        <span className="material-symbols-outlined">menu</span>
      </button>

      <aside className={isSidebarOpen ? "open" : ""}>
        <div className="toggle">
          <div className="logo">
            <img src={image_bp} alt="logo-bp" />
            <a href="/">
              <h2>
                <span>My</span>
                <span className="strong">App</span>
              </h2>
            </a>
          </div>
          <div className="close" id="close-sidebar" onClick={toggleSidebar}>
            <span className="material-symbols-outlined">close</span>
          </div>
        </div>
        <div className="sidebar">
          {elements
            .filter((item) => permissions[item.permissionKey])
            .map((item, index) => (
              <div
                key={index}
                className={`sidebar-link ${
                  location.pathname === item.pageLink ? "active" : ""
                }`}
                onClick={() => handleNavigation(item.pageLink)}
              >
                <span className="material-symbols-outlined">
                  {item.pageIcon}
                </span>
                <h3>{item.pageHeader}</h3>
              </div>
            ))}
        </div>
      </aside>
    </>
  );
});

export default SideBar;
